<template>
  <div class="border-bottom py-1">
    <div class="row">
      <div class="col-md-8">
        <label>
          {{data.name}}&nbsp;
          <span class="text-muted" v-html="numChars"></span>
        </label>
        <input
          class="form-control text-center my-1"
          type="text"
          v-model="dato.valor"
          :maxLength="(data.chars_num === 0) ? 99 : data.chars_num"
        />
      </div>
      <div class="col-md-4">
        <label>&nbsp;</label>
        <button
          class="btn btn-sm p-2 btn-secondary btn-gr float-right w-100 mt-2"
          @click="$refs.fileInput.click()"
        >
          <i class="fa fa-file" aria-hidden="true"></i>
          &nbsp;{{$t('guardar')}}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "inscripcions-data-comp",
  props: ["data"],
  data: () => ({
    dato: {
      docId: null,
      datos: null,
      valor: null
    }
  }),
  computed: {
    numChars() {
      if (this.data.chars_num > 0 && this.dato.valor !== null) {
        return (
          "(" +
          (this.data.chars_num - this.dato.valor.length) +
          " " +
          this.$t("caracteres") +
          ")"
        );
      } else if (this.data.chars_num > 0 && this.dato.valor === null) {
        return this.data.chars_num + " " + this.$t("caracteres");
      }
    }
  },
  mounted() {
    this.dato.datos = this.data;
    this.dato.docId = this.data.id;
  }
};
</script>

<style scoped>
input {
  height: 36px !important;
  color: black;
  font-size: 22px;
}
</style>